export function formDates(){
    gform.addFilter('gform_datepicker_options_pre_init', function(optionsObj, formId, fieldId) {
        // Set the minimum date for start date field to tomorrow
        if (formId == 1 && fieldId == 9) { // Replace with your actual form ID and field ID for the start date
            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            optionsObj.minDate = tomorrow;
            optionsObj.dateFormat = 'dd/mm/yy';
        }

        // Set the minimum date for end date field to the selected start date
        if (formId == 1 && fieldId == 10) { // Replace with your actual form ID and field ID for the end date
            optionsObj.onClose = function(dateText, inst) {
                var startDateText = jQuery('#input_1_9').val(); // Replace with your actual start date field ID
                if (startDateText) {
                    var parts = startDateText.split('/');
                    var startDate = new Date(parts[2], parts[1] - 1, parts[0]);
                    jQuery('#input_1_10').datepicker('option', 'minDate', startDate); // Replace with your actual end date field ID
                }
            };
            optionsObj.dateFormat = 'dd/mm/yy';
        }

        return optionsObj;
    });
}

// Gravity Forms 3 replaced the jQuery UI datepicker, so the range can't be set with
// .datepicker('option'). Store it on the input instead; GF reads it through the
// options filter when the picker initialises (on first focus of the field).
let restrictFilterAdded = false;

export function restrictDatepicker(dateField, start, end) {
    if (!dateField) return;
    dateField.dataset.minDate = start || '';
    dateField.dataset.maxDate = end || '';

    if (restrictFilterAdded || !window.gform || !window.gform.addFilter) return;
    restrictFilterAdded = true;

    window.gform.addFilter('gform_datepicker_options_pre_init', function(optionsObj, formId, fieldId) {
        const input = document.getElementById(`input_${formId}_${fieldId}`);
        if (!input) return optionsObj;
        const minDate = new Date(input.dataset.minDate);
        const maxDate = new Date(input.dataset.maxDate);
        if (!isNaN(minDate)) optionsObj.minDate = minDate;
        if (!isNaN(maxDate)) optionsObj.maxDate = maxDate;
        return optionsObj;
    });
}
